import useSyncBasket from '~/hooks/useSyncBasket.ts';
import useSyncLike from '~/hooks/useSyncLike.ts';

export default function useSyncShopping() {
  useSyncBasket();
  useSyncLike();
}
